import React from 'react';
import { Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '1rem',
    marginBottom: '8px',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    width:"100%"
  },
  tableCell: {
    padding: '1px 70px ', // Aumentar el padding para más ancho
    flex: '1', // Distribuir el espacio de manera uniforme
    width:'272px'
  },
  estadoCircle: {
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    marginRight: '10px',
  },
}));

const getColorForEstado = (estado) => {
  if (estado === 'ACTIVO') {
    return 'green';
  } else if (estado === 'INACTIVO') {
    return 'red';
  } else {
    return 'gray';
  }
};
const formatFecha = (fechaStr) => {
  if (!fechaStr) {
    return '-';
  }

  const fecha = new Date(fechaStr);
  const dia = fecha.getDate();
  const mes = fecha.getMonth() + 1;
  const año = fecha.getFullYear();
  const horas = fecha.getHours();
  const minutos = fecha.getMinutes();

  // Agregar ceros principales si es necesario
  const diaStr = dia < 10 ? `0${dia}` : dia;
  const mesStr = mes < 10 ? `0${mes}` : mes;
  const horasStr = horas < 10 ? `0${horas}` : horas;
  const minutosStr = minutos < 10 ? `0${minutos}` : minutos;

  return `${diaStr}/${mesStr}/${año} ${horasStr}:${minutosStr}`;
};

const TarjetaModulo = ({ modulo, estado, ultimaConexion, ultimaMedicion }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <div className={classes.tableCell}>
        <Typography variant="h5" style={{ textAlign: 'left', fontSize: '25px', fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",marginLeft:'-18%'}}color='primary'>
          {modulo || '-'}
        </Typography>
      </div>
      <div className={classes.tableCell}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div
            className={classes.estadoCircle}
            style={{ backgroundColor: getColorForEstado(estado),marginLeft:'-20%' }}
          ></div>
          <Typography variant="body1"style={{ textAlign: 'left', fontFamily: "'Segoe UI Variable Static Display 700', sans-serif"}}>
            {estado || '-'}
          </Typography>
        </div>
      </div>
      <div className={classes.tableCell}>
        <Typography variant="body1"style={{ textAlign: 'left', fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",marginLeft:'-40%'}}>
          {formatFecha(ultimaConexion)}
        </Typography>
      </div>
      <div className={classes.tableCell}>
        <Typography variant="body1">
          {formatFecha(ultimaMedicion)}
        </Typography>
      </div>
    </Paper>
  );
};

export default TarjetaModulo;